import {LabelShowManager} from './LabelShowManager';
import {RichText} from '@gongxigames/framework/core';

export type Message = {
    localeId?: string;
    text?: string;
    style?: string;
    values?: Record<string, string>;
};

export const TICKER_TEXT_FIELD_ID = 'ticker';

export class TickerManager {
    constructor(
        readonly labelShowManager: LabelShowManager,
        readonly text: RichText,
    ) {}

    public show(data: Message): void {
        this.text.updateText({
            id: data.localeId,
            customText: data.text,
            style: data.style,
            values: data.values,
        });

        this.labelShowManager.show(TICKER_TEXT_FIELD_ID);
    }

    public hide(data: Message): void {
        this.labelShowManager.hide(TICKER_TEXT_FIELD_ID);
    }
}